import { useMemo } from 'react'
import type { ProductRecord } from '@/types/dashboard'
import {
  createStudioReviewDataClient,
  type StudioReviewDataClient,
} from '@/services/dashboard-api'
import { useDashboardSlice, useReloadToken } from './dashboard-data-state'
import type { DashboardSlice } from './dashboard-data-state'

export interface ProductsData extends DashboardSlice<ProductRecord[]> {
  isLoading: boolean
  reload: () => void
}

export function useProductsData(injectedClient?: StudioReviewDataClient): ProductsData {
  const defaultClient = useMemo(() => createStudioReviewDataClient(), [])
  const client = injectedClient ?? defaultClient
  const [reloadToken, reload] = useReloadToken()
  const slice = useDashboardSlice(
    'source packets',
    () => client.readSources(),
    [client],
    reloadToken,
  )
  return { ...slice, isLoading: slice.status === 'loading', reload }
}
